"use client";

import { AccountView } from "better-auth-ui";

/**
 * Stretch the cards (and their flex wrapper) to fill the content column.
 * Hoisted to a module constant so it's a stable reference across renders
 * (avoids a new object literal in JSX on every render).
 */
const accountViewClassNames = { base: "w-full", cards: "w-full" } as const;

export type AccountSettingsProps = {
  /**
   * The account sub-view segment from the route (e.g. "settings" | "security").
   * Forwarded to better-auth-ui's `AccountView`, which falls back to the
   * settings view when omitted.
   */
  readonly path?: string;
};

/**
 * Account settings cards for the dedicated `/account` page.
 *
 * Renders better-auth-ui's `AccountView` with `hideNav` so its built-in
 * sidebar / mobile sub-nav are dropped — the app's own settings sidebar
 * (`settings-sidebar.tsx`) is the single settings navigation. `AccountView`
 * still selects the correct cards from the `path` segment and keeps every
 * real update flow (name, email, password, sessions) wired through the
 * better-auth client. The cards stretch to fill the content column.
 */
export function AccountSettings({ path }: AccountSettingsProps) {
  return <AccountView hideNav classNames={accountViewClassNames} {...(path ? { path } : {})} />;
}
